<div class="login-body">

  <div class="tw:w-full tw:px-[15px] tw:mx-auto">
    <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
      <div class="tw:w-full tw:px-[15px]">
        <app-login-brand></app-login-brand>
      </div>
      @if (showPasswordGenerate) {
        <div class="tw:w-full tw:px-[15px] tw:mx-auto" style="max-width: 800px;">
          <div class="tw:w-full tw:px-[15px] tw:mx-auto">
            <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:pb-6">
              <div class="tw:w-full tw:px-[15px] tw:mb-6">
                <div class="tw:text-center">
                  <h3 class="tw:text-white">Generate Access to Tuition</h3>
                </div>
              </div>
              <div class="tw:w-full tw:px-[15px] tw:mb-6 tw:mt-6">
                <label class="tw:text-white font-17"> Please choose your favourite password method to access the site:</label>
              </div>
              <div class="tw:w-full tw:px-[15px] tw:my-2">
                <div class="button-container">
                  <button type="button" class="btn-outline-light btn-lg tw:w-full" (click)="generateAccess('emoji')">Emoji Key</button>
                </div>
                <div class="description-container tw:pl-2">
                  <label class="tw:text-white tw:pt-2 tw:ml-3 font-16">Auto generate a 4 Emoji Key</label>
                </div>
              </div>
              <div class="tw:w-full tw:px-[15px] tw:my-2">
                <div class="button-container">
                  <button type="button" class="btn-outline-light btn-lg tw:w-full" (click)="generateAccess('number')">PIN</button>
                </div>
                <div class="description-container tw:pl-2">
                  <label class="tw:text-white tw:pt-2 tw:ml-3 font-16">Auto generate a 4 Digit PIN</label>
                </div>
              </div>
              @if (generatedSuccessfully) {
                <div class="tw:w-full tw:px-[15px] tw:mt-4">
                  <div class="tw:flex tw:flex-wrap tw:p-0 tw:m-0 tw:mb-4 tw:mt-4 tw:pt-4">
                    <div class="tw:w-full tw:p-0 tw:mb-4">
                      <label class="tw:text-white font-17">Your auto generated {{isNumericPin ? 'PIN' : 'Emoji key'}} is:</label>
                    </div>
                    <div class="tw:flex-1 tw:p-0 tw:m-0 tw:mr-1 tw:flex tw:justify-start">
                      <div #pin1 class="pin-box tw:md:float-left tw:inline-block tw:mx-1" [ngClass]="{'tw:pt-6': isNumericPin, 'pin-box-emoji': !isNumericPin}"></div>
                      <div #pin2 class="pin-box tw:md:float-left tw:inline-block tw:mx-1" [ngClass]="{'tw:pt-6': isNumericPin, 'pin-box-emoji': !isNumericPin}"></div>
                      <div #pin3 class="pin-box tw:md:float-left tw:inline-block tw:mx-1" [ngClass]="{'tw:pt-6': isNumericPin, 'pin-box-emoji': !isNumericPin}"></div>
                      <div #pin4 class="pin-box tw:md:float-left tw:inline-block tw:mx-1" [ngClass]="{'tw:pt-6': isNumericPin, 'pin-box-emoji': !isNumericPin}"></div>
                    </div>
                    <div class="tw:w-full tw:p-0 tw:mt-6">
                      @if (isNumericPin) {
                        <label class="tw:text-white font-17">Please remember your PIN and when prompted on the <a class="pupil-login-link" [routerLink]="['/student-login']">Learner Login page</a>, just enter the PIN using the on-screen keypad.</label>
                      }
                      @if (!isNumericPin) {
                        <label class="tw:text-white font-17">Please remember these 4 Emojis and their display order.  When prompted on the <a class="pupil-login-link" [routerLink]="['/student-login']">Learner Login page</a>, just enter the Emojis using the on-screen keypad.</label>
                      }
                    </div>
                  </div>
                </div>
              }
              @if (showGenerateErrorMessage) {
                <div class="tw:w-full tw:px-[15px] tw:pt-4">
                  <label class="tw:text-danger">{{generateErrorMessage}}</label>
                </div>
              }
            </div>
          </div>
          <br />
          <div class="tw:py-0 tw:px-6 tw:m-0 tw:pt-6 tw:md:pt-0 tw:text-center">
            <button class="btn-outline-light btn-lg" style="width: 192px;" type="button" [routerLink]="['/student-login']">Back to login</button>
          </div>
        </div>
      }
      @if (showError) {
        <div class="tw:w-full tw:px-[15px]">
          <div class="flex-row tw:m-0 tw:p-0">
            <div class="flex-column tw:m-0 tw:p-0">
              <div class="authError-icon authError-error animateErrorIcon tw:block">
                <span class="authError-x-mark animateXMark">
                  <span class="authError-line authError-left"></span>
                  <span class="authError-line authError-right"></span>
                </span>
              </div>
            </div>
          </div>
          <div class="flex-row tw:m-0 tw:p-0">
            <div class="flex-column tw:m-0 tw:p-0 tw:text-center">
              <h3 class="tw:text-white">Oops...</h3>
              <label class="tw:text-white">{{ errorMessage }}</label>
              <br />
              <div class="tw:p-0 tw:m-0 tw:pt-6 tw:md:pt-0">
                <button class="btn-outline-light btn-lg" type="button" [routerLink]="['/student-login']">Back to login</button>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>

</div>